
import { createContext } from 'react'

const SchedulesCtx = createContext({
  schedulesList: [],
})

export default SchedulesCtx
